import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { GET_AVAILABLE_VEHICLES, GET_AVAILABLE_VEHICLES_ERROR, GET_AVAILABLE_VEHICLES_SUCCESS } from '../../../actions.js';

function* getAvailableVehicles({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/bookings/${payload?.id}/available-vehicles`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_AVAILABLE_VEHICLES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_AVAILABLE_VEHICLES_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_AVAILABLE_VEHICLES_ERROR, payload: error });
  }
}

export function* watchGetAvailableVehicles() {
  yield takeEvery(GET_AVAILABLE_VEHICLES, getAvailableVehicles);
}

function* getAvailableVehiclesSaga() {
  yield all([fork(watchGetAvailableVehicles)]);
}

export default getAvailableVehiclesSaga;
